module.exports = __webpack_public_path__ + "static/media/linkBottomImg1.b6877102.png";